document.addEventListener("DOMContentLoaded", function(){

  function isDekstop() {
    var e = window, 
        a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    if ( e[ a+'Width' ] >= 768 ) {
      return  true;
    } else {
      return false;
    }
  }

  window.luv_aj = window.luv_aj || {};
  const luv_aj = window.luv_aj;
  const logo = document.querySelector('.js-logo');
  const fashion_fine_elements = document.querySelectorAll('.js-fashion-fine');
  const fashion_logo = document.querySelector('.js-logo-fashion');
  const fine_logo = document.querySelector('.js-logo-fine');
  const fashion_tab = document.querySelector('.js-header-tab-fashion');
  const fine_tab = document.querySelector('.js-header-tab-fine');
  const sidebar_links = document.querySelector('.js-sidebar-links');
  const sidebar_fashion = document.querySelector('.js-sidebar-fashion');
  const sidebar_fine = document.querySelector('.js-sidebar-fine');
  const promo_bar = document.querySelector('.js-promo-msg-bar');
  
  luv_aj.page_fine = document.querySelector('.js-header-menu').dataset.fine === 'true';
  luv_aj.has_default = document.querySelector('.js-header-menu').dataset.fineDefault === 'true';

  if (luv_aj.has_default) {
    luv_aj.is_fine = luv_aj.page_fine;
  } else {
    luv_aj.is_fine = localStorage.getItem('luv_aj_fine') === 'true' || false;
  }

  localStorage.setItem('luv_aj_fine', luv_aj.is_fine);

  if (luv_aj.is_fine) {
    // console.log('fine');

    fashion_fine_elements.forEach((elem) => {
      elem.classList.add('fine-active');
      elem.classList.remove('fashion-active');
    });

    logo.href = fine_tab.href;

    fashion_logo.classList.add('hidden');
    fine_logo.classList.remove('hidden');

    promo_bar.classList.add('fine-active');

    if (sidebar_links) {
      sidebar_fashion.classList.add('sidebar-links__nav--hidden');
      sidebar_fine.classList.remove('sidebar-links__nav--hidden');
    }
  } else {
    // console.log('fashion');

    fashion_fine_elements.forEach((elem) => {
      elem.classList.remove('fine-active');
      elem.classList.add('fashion-active');
    });

    logo.href = fashion_tab.href;

    fashion_logo.classList.remove('hidden');
    fine_logo.classList.add('hidden');

    promo_bar.classList.add('fashion-active');

    if (sidebar_links) {
      sidebar_fashion.classList.remove('sidebar-links__nav--hidden');
      sidebar_fine.classList.add('sidebar-links__nav--hidden');
    }
  }
  
  if (sidebar_links) {
    sidebar_links.classList.add('sidebar-links--active');
  }

  const header_overlay = document.querySelector('.js-header-overlay');
  const shop_menu_button = document.querySelector('.js-header-nav-shop');
  const shop_menu = document.querySelector('.js-shop-menu');
  const shop_menu_accordions = document.querySelectorAll('.js-shop-menu-accordion');
  // const mobile_menu_button = document.querySelector('');

  shop_menu_button.addEventListener('click', (e) => {
    if (shop_menu_button.classList.contains('active')) {
      shop_menu_button.classList.remove('active');
      header_overlay.addEventListener('transitionend', (e) => {
        shop_menu.classList.add('hidden');
        header_overlay.classList.add('hidden');
      }, {once: true});
      shop_menu.classList.remove('active');
      header_overlay.classList.remove('active');
    } else {
      shop_menu_button.classList.add('active');
      shop_menu.classList.remove('hidden');
      header_overlay.classList.remove('hidden');
      window.requestAnimationFrame(() => {
        shop_menu.classList.add('active');
        header_overlay.classList.add('active');
      });
    }
  });

  shop_menu_accordions.forEach((elem) => {
    let button = elem.querySelector('.js-shop-menu-accordion-button');

    button?.addEventListener('click', (e) => {
      // if (button.closest('.shop-menu-accordion').classList.contains('shop-menu-accordion--open')) {
      //   console.log('close open slider');
      //   let open_accordion = button.closest('.shop-menu-accordion');
      //   open_accordion.classList.remove('shop-menu-accordion--open');
      //   open_accordion.querySelector('.js-shop-menu-accordion-slider').style.maxHeight = null;
      // } else {
      //   let open_accordion = document.querySelector('.shop-menu-accordion--open');
      //   if (open_accordion) {
      //     open_accordion.classList.remove('shop-menu-accordion--open');
      //     open_accordion.querySelector('.js-shop-menu-accordion-slider').style.maxHeight = null;
      //   }
      // }
      // shop_menu_accordions.forEach((accordion) => {
      //   if(accordion.classList.contains('shop-menu-accordion--open')) {
      //     accordion.classList.remove('shop-menu-accordion--open');
      //     accordion.querySelector('.js-shop-menu-accordion-slider').style.maxHeight = null;
      //   }
      // });

      if (document.querySelector('.shop-menu-accordion--open') !== elem) {
        let open_accordion = document.querySelector('.shop-menu-accordion--open');
        if (open_accordion) {
          open_accordion.classList.remove('shop-menu-accordion--open');
          open_accordion.querySelector('.js-shop-menu-accordion-slider').style.maxHeight = null;
        }
      }

      elem.classList.toggle('shop-menu-accordion--open');
      let container = elem.querySelector('.js-shop-menu-accordion-slider');
      if (container.style.maxHeight) {
        container.style.maxHeight = null;
      } else {
        container.style.maxHeight = container.scrollHeight + 'px';
      }
    });
  });

  const shop_menu_link = document.querySelectorAll('.js-shop-menu-fashion .js-shop-menu-link');

  shop_menu_link.forEach((link) => {
    let link_href = link.getAttribute('href');
    link.addEventListener('mouseover', (e) => {
      document.querySelector('.js-shop-menu-fashion .shop-menu-images__image--active')?.classList.remove('shop-menu-images__image--active');
      document.querySelector(`.js-shop-menu-fashion [data-image-link="${link_href}"]`)?.classList.add('shop-menu-images__image--active')
    });
  });

  const shop_menu_fine_link = document.querySelectorAll('.js-shop-menu-fine .js-shop-menu-link');

  shop_menu_fine_link.forEach((link) => {
    let link_href = link.getAttribute('href');
    link.addEventListener('mouseover', (e) => {
      document.querySelector('.js-shop-menu-fine .shop-menu-images__image--active')?.classList.remove('shop-menu-images__image--active');
      document.querySelector(`.js-shop-menu-fine [data-image-link="${link_href}"]`)?.classList.add('shop-menu-images__image--active')
    });
  });

  // Animated logo
  const anim_logo = document.querySelector('.js-animated-logo');

  if (!luv_aj.page_fine) {
    window.addEventListener('scroll', function() {
      let trigger = 120;
      if (window.innerWidth >= 1024) {
        trigger = 200;
      } else if (window.innerWidth >= 768) {
        trigger = 160;
      }
  
      if (window.scrollY >= trigger) {
        window.requestAnimationFrame(() => {
          anim_logo.classList.remove('invisible');
          window.requestAnimationFrame(() => {
            anim_logo.classList.add('animated-logo--active');
          });
        });
      } else {
        anim_logo.addEventListener('transitionend', (e) => {
          anim_logo.classList.add('invisible');
        }, {once: true});
        window.requestAnimationFrame(() => {
          anim_logo.classList.remove('animated-logo--active');
        });
      }
    }); 
  }

  // const animationObserver = new IntersectionObserver(entries => {
  //   // Loop over the entries
  //   entries.forEach(entry => {
  //     // If the element is visible
  //     if (entry.isIntersecting) {
  //       window.requestAnimationFrame(() => {
  //         anim_logo.classList.remove('invisible');
  //         window.requestAnimationFrame(() => {
  //           anim_logo.classList.add('animated-logo--active');
  //         });
  //       });
  //     }
  //   });
  // });
  
  // animationObserver.observe(anim_logo_sentinel);

  // Mobile Menu
  const mobile_menu_button = document.querySelector('.js-mobile-menu-button'),
        mobile_menu_accordions = document.querySelectorAll('.js-mobile-menu-accordion');

  mobile_menu_button.addEventListener('click', () => {
    document.body.classList.toggle('mobile-menu--open');
    document.body.classList.toggle('prevent-scroll');
  });

  mobile_menu_accordions.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      elem.classList.toggle('mobile-menu__accordion-button--open');
      let container = elem.nextElementSibling;
      if (container.style.maxHeight) {
        container.style.maxHeight = null;
      } else {
        container.style.maxHeight = container.scrollHeight + 'px';
      }
    });
  });

  let mobile_menus = document.querySelectorAll('.js-mobile-menu');
  
  mobile_menus.forEach((elem) => {
    let first_accordion = elem.querySelector('.js-mobile-menu-accordion').nextElementSibling;
    first_accordion.style.maxHeight = first_accordion.scrollHeight + 'px';
  });


  // Homepage Animations
	function homePageAnimations() {
		var desktop = false;
		var e = window, 
				a = 'inner';
		if (!('innerWidth' in window )) {
				a = 'client';
				e = document.documentElement || document.body;
		}
		if ( e[ a+'Width' ] >= 1024 ) {
			desktop =  true;
		}
		if (desktop) {
			const animationObserver = new IntersectionObserver(entries => {
				// Loop over the entries
				entries.forEach(entry => {
					// If the element is visible
					if (entry.isIntersecting) {
						let animation = entry.target.dataset.animated,
								delay = entry.target.dataset.delay;
						// Add the animation class
						entry.target.classList.add('animated');
						entry.target.classList.add(delay);
						entry.target.classList.add(animation);
					}
				});
			});
			
			let animatedElements = Array.from(document.getElementsByClassName('js-anim-elem'));
		
			animatedElements.forEach(elem => {
				animationObserver.observe(elem);
			})
		}
	}

	if (document.getElementById('luv-aj') || document.querySelector('.js-anim-elem')) {
		// instagramSections();
		homePageAnimations();
	}

  // Homepage Slider
  const homepage_sliders = document.querySelectorAll('.js-homepage-banner-slides');
  homepage_sliders.forEach((elem) => {
    if (elem.childElementCount > 1) {
      let flkty = new Flickity( elem, {
        // options
        imagesLoaded: true,
        cellAlign: 'left',
        autoPlay: 3000,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize'));
          }
        }
      });
    }
  });


  // Featured Collection Slider
  const featured_collection_sliders = document.querySelectorAll('.js-featured-collection-slides');
  featured_collection_sliders.forEach((elem) => {
    if (elem.childElementCount > 1) {
      let flkty = new Flickity( elem, {
        // options
        imagesLoaded: true,
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize'));
          }
        }
      });
    }
  });

  // FAQ Accordions
  const accordionBtns = document.querySelectorAll('.js-faq-accordion-button');
  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      
      this.classList.toggle('is-open');
      let content = this.nextElementSibling;
      if (content.style.maxHeight) {
        //this is if the accordion is open
        content.style.maxHeight = null;
      } else {
        //if the accordion is currently closed
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    };
  });

  // Play and pause video element
  if (document.querySelector('.video-diptych__video')) {
    let videos = document.querySelectorAll('.video-diptych__video');
    videos.forEach(function(element){
      let video = element.querySelector('.js-video');
      playPauseBtn = element.querySelector('.js-play-pause');
      element.querySelector('.js-play-icon').style.display = 'none';
      playPauseBtn.addEventListener('click', (e) => {
        if (video.paused) {
          video.play();
          playPauseBtn.querySelector('.visually-hidden').textContent = 'Pause';
          playPauseBtn.querySelector('.js-play-icon').style.display = 'none';
          playPauseBtn.querySelector('.js-pause-icon').style.display = 'block';
        } else {
          video.pause();
          playPauseBtn.querySelector('.visually-hidden').textContent = 'Play';
          playPauseBtn.querySelector('.js-play-icon').style.display = 'block';
          playPauseBtn.querySelector('.js-pause-icon').style.display = 'none';
        }
      });
    });
  }

  $('#play-pause-button').click(function () {
    var mediaVideo = $("#media-video").get(0);
    if (mediaVideo.paused) {
        mediaVideo.play();
    } else {
        mediaVideo.pause();
  }
  });

  // Collection load more observer
  const collection_grid = document.querySelector('.js-collection-products');
  const collection_sentinel = document.querySelector('.js-collection-load-more-sentinel');

  function loadMoreProducts() {
    var collection_data = {
      current_page: collection_sentinel.dataset.currentPage,
      next_page: collection_sentinel.dataset.nextPage,
      total_pages: collection_sentinel.dataset.totalPages
    };

    const load_more_observer = new IntersectionObserver(entries => {
      // Loop over the entries
      entries.forEach(entry => {
        // If the element is visible
        if (entry.isIntersecting) {

          // console.log('time to load');

          load_more_observer.unobserve(collection_sentinel);
          collection_data.current_page++;
          collection_data.next_page = collection_data.next_page.replace(/page=[0-9]+/,`page=${collection_data.current_page}`);
          // collection_sentinel.setAttribute('data-current-page', collection_data.current_page++);
          // collection_sentinel.setAttribute('data-next-page', collection_sentinel.dataset.nextPage.replace(/page=[0-9]+/,`page=${collection_data.current_page}`));

          var headers = JSON.parse(
            JSON.stringify({
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'text/html;'
              }
            })
          );
          var request = {
              method: 'GET',
              headers: headers
          };
          fetch(collection_data.next_page, request)
          .then((response) => {
            if (!response.ok) {
              throw Error(response.statusText);
            }
            // console.log('response',response);
            return response.text();
          })
          .then((data) => {
            // console.log('data', data);
            var parser = new DOMParser();
            var page = parser.parseFromString(data, 'text/html');
            let new_products = page.querySelectorAll('.js-collection-product');
            // console.log(new_products);

            let number_of_entries = document.querySelectorAll('.js-collection-product').length + document.querySelectorAll('.js-collection-products .js-campaign-images').length;

            let doc_frag = document.createDocumentFragment();
            for (let i = 0, limit = new_products.length; i < limit; i++) {
              doc_frag.append(new_products[i]);
            }
            collection_grid.append(doc_frag);

            if (document.querySelector('.js-shop-look')) {
              placeLooks(number_of_entries, new_products.length)
            } else if (document.querySelector('.js-campaign-images')) {
              placeCampaignImages(number_of_entries, new_products.length);
            }

            plpGSSwatches();
            updateSoldOutGold();

            if(collection_data.current_page < collection_data.total_pages) {
              load_more_observer.observe(collection_sentinel);
            } else {
              load_more_observer.disconnect();
              collection_sentinel.classList.add('hidden');
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      });
    });

    load_more_observer.observe(collection_sentinel);
  }

  if (collection_sentinel) {
    loadMoreProducts();
  }

  function placeLooks(number_of_entries, new_entries) {

    const buttons = document.querySelectorAll('.js-shop-look-card');
    const bg = document.querySelector('.js-shop-look-drawer-bg');
    const drawers = document.querySelectorAll('.js-shop-look-drawer');
    const close_drawer = document.querySelectorAll('.js-shop-look-close-drawer');
    let updated_entries_total = number_of_entries + new_entries;
    const looks = Array.from(document.querySelectorAll('.js-shop-look-card'));
		const collection_matrix = Array.from(document.querySelectorAll('.js-collection-product'));
		let updated_matrix = document.createDocumentFragment();

		for (let i = 0, limit = looks.length; i < limit; i ++) {
			let look = looks[i];
      let look_number = look.dataset.position - 1;
      if (look_number <= updated_entries_total) {
        collection_matrix.splice((look_number), 0, look);
        updated_entries_total++;
      }
		}
		
		for (let i = 0, limit = collection_matrix.length; i < limit; i ++) {
			updated_matrix.append(collection_matrix[i]);
		}
		let more = document.querySelector('.more');
		if (more) {
			updated_matrix.append(more);
      // loadMoreProducts();	
		}
		let collection =  document.querySelector('.js-collection-products');
		collection.innerHTML = '';
		collection.appendChild(updated_matrix);
    
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        drawers.forEach((drawer) => {
          drawer.classList.remove('shop-look-drawer--open');
          drawer.querySelector('.shop-look-drawer-scroll').scrollTo(0, 0);
        });
        drawers[parseInt(button.dataset.index)].classList.add('shop-look-drawer--open');

        window.requestAnimationFrame(() => {
          bg.classList.add('shop-look-drawer-bg--active');
          window.requestAnimationFrame(() => {
            bg.classList.add('shop-look-drawer-bg--transition');
          });
        });
      });
    });

    close_drawer.forEach((button) => {
      button.addEventListener('click', (e) => {
        button.closest('.js-shop-look-drawer').classList.remove('shop-look-drawer--open');

        bg.addEventListener('transitionend', (e) => {
          window.requestAnimationFrame(() => {
            bg.classList.remove('shop-look-drawer-bg--active');
          });
        }, {once: true});
        bg.classList.remove('shop-look-drawer-bg--transition');
      });
    });
    
    bg.addEventListener('click', (e) => {
      drawers.forEach((drawer) => {
        drawer.classList.remove('shop-look-drawer--open');
      });
      bg.addEventListener('transitionend', (e) => {
        window.requestAnimationFrame(() => {
          bg.classList.remove('shop-look-drawer-bg--active');
        });
      }, {once: true});
      bg.classList.remove('shop-look-drawer-bg--transition');
    });
  }

  function placeCampaignImages(number_of_entries, new_entries) {
    let updated_entries_total = number_of_entries + new_entries;
    const images = Array.from(document.querySelectorAll('.js-campaign-images'));
		const collection_matrix = Array.from(document.querySelectorAll('.js-collection-product'));
		let updated_matrix = document.createDocumentFragment();

		for (let i = 0, limit = images.length; i < limit; i ++) {
			let image = images[i];
      let image_number = image.dataset.index - 1;
      if (image_number <= updated_entries_total) {
        collection_matrix.splice((image_number), 0, image);
        updated_entries_total++;
      }
		}
		
		for (let i = 0, limit = collection_matrix.length; i < limit; i ++) {
			updated_matrix.append(collection_matrix[i]);
		}
		let more = document.querySelector('.more');
		if (more) {
			updated_matrix.append(more);
      // loadMoreProducts();	
		}
		let collection =  document.querySelector('.js-collection-products');
		collection.innerHTML = '';
		collection.appendChild(updated_matrix);
  }

  // Landing Page Campaign Images
  if (document.querySelector('.js-shop-look')) {
    placeLooks(0, 48)
  } else if (document.querySelector('.js-campaign-images')) {
    placeCampaignImages(0, 48);
	}

  if (document.getElementById('sort-by')) {
    let options = document.getElementById('sort-by').options;

    for (let i = 0, limit = options.length; i < limit; i++) {
      let query = options[i].value.substring(options[i].value.indexOf('?'));
      if (window.location.href.includes(query)) {
        options[i].selected = true;
      }
    }
  }

  // Best Sellers Slider
  const best_seller_sliders = document.querySelectorAll('.js-image-carousel');
  best_seller_sliders.forEach((elem) => {
    if (elem.childElementCount > 1) {
      let flkty = new Flickity( elem, {
        // options
        imagesLoaded: true,
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize'));
            elem.classList.remove('opacity-0');
          }
        }
      });
    }
  });

  // Coming Soon Slider
  const coming_soon_sliders = document.querySelectorAll('.js-coming-soon-images');
  coming_soon_sliders.forEach((elem) => {
    if (elem.childElementCount > 1) {
      let flkty = new Flickity( elem, {
        // options
        imagesLoaded: true,
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize'));
            elem.classList.remove('opacity-0');
          }
        }
      });
    }
  });

  // AB Test Masonry Collection
  if (document.querySelector('.collection-masonry')) {
    // console.log('masonry');
    let collection = document.querySelector('.collection-masonry');
    var msnry = new Masonry( collection, {
      // options
      itemSelector: '.masonry-product',
      columnWidth: '.masonry-sizer',
      percentPosition: true,
      gutter: 12,
      horizontalOrder: true
    });
  }

  if (document.getElementById('variant-selector')) {
    const variant_selector = document.getElementById('variant-selector');
    const variant_price = document.querySelector('.js-variant-price');
    const compare_at_price = document.querySelector('.js-compare-at-price');
    
    variant_selector.addEventListener('change', (e) => {

      variant_price.textContent = variant_selector.options[variant_selector.selectedIndex].dataset.price;

      if (compare_at_price) {
        compare_at_price.textContent = variant_selector.options[variant_selector.selectedIndex].dataset?.compare;
      }
      
      let selected_variant = variant_selector.options[variant_selector.selectedIndex];
      disableATCSoldOut(selected_variant);

      variantActions();
    });

    variantActions();
  }

  function variantActions() {

      // Check product_json for sold out info
      // Update the buttons accordingly based on selected product
      // Check for variant option 1, then base the other option buttons on option 1's value

      // let selected_size = size_selector.options[size_selector.selectedIndex];

      const variant_selector = document.getElementById('variant-selector');
      const product_json = JSON.parse(document.querySelector('.js-product-json').innerHTML);

      const size_selector = document.querySelector('.js-product-option-size');
      const gs_selector = document.querySelector('.js-product-gold-silver-selector.product-gold-silver-selector--selected')?.dataset.color;
      // console.log('product_json',product_json);

      // Size selector
      let sizes = [];
      if (gs_selector && size_selector) {
        let variants = product_json.variants;
        for (let i = 0, limit = variants.length; i < limit; i++) {
          if (variants[i].option1 === gs_selector) {
            sizes.push(variants[i]);
          }
        }

        for (let i = 0, limit = sizes.length; i < limit; i++) {
          let size = size_selector.querySelector(`option[value='${sizes[i].option2}']`);
          // console.log('size',size);

          if (variant_selector.querySelector(`option[value='${sizes[i].id}']`).dataset.soldOut === 'true') {
            // console.log('sold out',variants[i],variant_selector.querySelector(`option[value='${sizes[i].id}']`));
            size.textContent = size.value + ' - Sold Out';
          } else {
            // console.log('not sold out',variants[i],variant_selector.querySelector(`option[value='${sizes[i].id}']`));
            size.textContent = size.value;
          }
        }

        // console.log('sizes',sizes);
      }

      // Fine variant options
      const var_option_btn = document.querySelectorAll('.js-variant-option-select');
      if (var_option_btn.length > 0) {

        if (var_option_btn.length === 1) {
          for (let i = 0, limit = variant_selector.options.length; i < limit; i++) {
            let button = document.querySelector(`.js-variant-option-button[data-value="${variant_selector.options[i].dataset.variant}"`);
            if (variant_selector.options[i].dataset.soldOut === 'true') {
              // console.log('sold out', variant_selector.options[i]);
              button.classList.remove('in-stock');
              button.classList.add('out-stock');
            } else {
              // console.log('in stock', variant_selector.options[i]);
              button.classList.add('in-stock');
              button.classList.remove('out-stock');
            }
          }
        }

        if (var_option_btn.length === 2) {
          let selected_id = parseInt(variant_selector.options[variant_selector.selectedIndex].value);
          let selected_variant = product_json.variants.find(variant => variant.id === selected_id);

          // console.log('selected_id', selected_id);
          // console.log('selected_variant', selected_variant);

          // Get variant option buttons
          const var_option_1_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[0]}"] .js-variant-option-button`);
          const var_option_2_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[1]}"] .js-variant-option-button`);

          // console.log('var_option_btns', var_option_1_btns, var_option_2_btns);

          // Track in-stock status of each option in variants_instock
          let variants_instock = Array.from(var_option_1_btns).reduce((acc, btn) => {
              let optionValue = btn.dataset.value;
              acc[optionValue] = product_json.variants
                  .filter(variant => variant.option1 === optionValue)
                  .map(variant => variant.available);
              return acc;
          }, {});

          // Update option 1 buttons' in-stock status
          var_option_1_btns.forEach(btn => {
              let optionValue = btn.dataset.value;
              if (variants_instock[optionValue].includes(true)) {
                btn.classList.add('in-stock');
                btn.classList.remove('out-stock');
              } else {
                btn.classList.remove('in-stock');
                btn.classList.add('out-stock');
              }
          });

          // console.log('variants_instock', variants_instock);

          // Update option 2 buttons' in-stock status based on selected option 1
          product_json.variants
              .filter(variant => variant.option1 === selected_variant.option1)
              .forEach(variant => {
                  let button = document.querySelector(`.js-variant-option-group[data-option='${product_json.options[1]}'] .js-variant-option-button[data-value='${variant.option2}']`);
                  if (button) {
                      if (variant.available) {
                          button.classList.add('in-stock');
                          button.classList.remove('out-stock');
                      } else {
                          button.classList.remove('in-stock');
                          button.classList.add('out-stock');
                      }
                  }
              });

        }

        if (var_option_btn.length === 3) {
          let selected_id = parseInt(variant_selector.options[variant_selector.selectedIndex].value);
          let selected_variant = product_json.variants.find(variant => variant.id === selected_id);

          // console.log('selected_id', selected_id);
          // console.log('selected_variant', selected_variant);

          // Get variant option buttons
          const var_option_1_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[0]}"] .js-variant-option-button`);
          const var_option_2_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[1]}"] .js-variant-option-button`);
          const var_option_3_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[2]}"] .js-variant-option-button`);

          // console.log('var_option_btns', var_option_1_btns, var_option_2_btns);

          // Track in-stock status of each option in variants_instock
          let variants_1_instock = Array.from(var_option_1_btns).reduce((acc, btn) => {
              let optionValue = btn.dataset.value;
              acc[optionValue] = product_json.variants
                  .filter(variant => variant.option1 === optionValue)
                  .map(variant => variant.available);
              return acc;
          }, {});

          // Update option 1 buttons' in-stock status
          var_option_1_btns.forEach(btn => {
              let optionValue = btn.dataset.value;
              if (variants_1_instock[optionValue].includes(true)) {
                btn.classList.add('in-stock');
                btn.classList.remove('out-stock');
              } else {
                btn.classList.remove('in-stock');
                btn.classList.add('out-stock');
              }
          });

          // Track in-stock status of each option in variants_instock
          let variants_2_instock = Array.from(var_option_2_btns).reduce((acc, btn) => {
              let optionValue = btn.dataset.value;
              acc[optionValue] = product_json.variants
                  .filter(variant => variant.option2 === optionValue && variant.option1 === selected_variant.option1)
                  .map(variant => variant.available);
              return acc;
          }, {});

          // console.log('variants_instock', variants_1_instock, variants_2_instock);

          // Update option 2 buttons' in-stock status
          var_option_2_btns.forEach(btn => {
              let optionValue = btn.dataset.value;
              if (variants_2_instock[optionValue].includes(true)) {
                btn.classList.add('in-stock');
                btn.classList.remove('out-stock');
              } else {
                btn.classList.remove('in-stock');
                btn.classList.add('out-stock');
              }
          });

          // Update option 3 buttons' in-stock status based on selected option 1
          product_json.variants
              .filter(variant => variant.option1 === selected_variant.option1 && variant.option2 === selected_variant.option2)
              .forEach(variant => {
                  let button = document.querySelector(`.js-variant-option-group[data-option='${product_json.options[2]}'] .js-variant-option-button[data-value='${variant.option3}']`);
                  if (button) {
                      if (variant.available) {
                          button.classList.add('in-stock');
                          button.classList.remove('out-stock');
                      } else {
                          button.classList.remove('in-stock');
                          button.classList.add('out-stock');
                      }
                  }
              });

        }

        // if (var_option_btn.length === 3) {
        //   // Determine which if any option1s are completely sold out
        //   // Determine which option2s are sold out of the selected option1 value
          
        //   // loop through each option 1 and check if any option 2s are available
        //   // loop through each option 2 for select option 1 and check if any are available

        //   let selected_id = parseInt(variant_selector.options[variant_selector.selectedIndex].value);
        //   let selected_variant;
          
        //   console.log('selected_id', selected_id);

        //   // Get selected option 1
        //   for (let i = 0, limit = product_json.variants.length; i < limit; i++) {
        //     if (product_json.variants[i].id === selected_id) {
        //       selected_variant = product_json.variants[i];
        //     }
        //   }

        //   const var_option_1_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[0]}"] .js-variant-option-button`);
        //   const var_option_2_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[1]}"] .js-variant-option-button`);
        //   const var_option_3_btns = document.querySelectorAll(`.js-variant-option-group[data-option="${product_json.options[2]}"] .js-variant-option-button`);

        //   console.log('selected_variant',selected_variant);
        //   console.log('var_option_btns',var_option_1_btns,var_option_2_btns,var_option_3_btns);

        //   let variants_1_instock = {};
        //   let variants_2_instock = {};

        //   for (let i = 0, limit = var_option_1_btns.length; i < limit; i++) {
        //     variants_instock[var_option_1_btns[i].dataset.value] = [];
        //     for (let j = 0, limit = product_json.variants.length; j < limit; j++) {
        //       if (product_json.variants[j].option1 === var_option_1_btns[i].dataset.value) {
        //         if (product_json.variants[j].available) {
        //           variants_instock[var_option_1_btns[i].dataset.value].push(true);
        //         } else {
        //           variants_instock[var_option_1_btns[i].dataset.value].push(false);
        //         }
        //       }
        //     }
        //   }

        //   for (let i = 0, limit = var_option_1_btns.length; i < limit; i++) {
        //     if (variants_instock[var_option_1_btns[i].dataset.value].includes(false)) {
        //       var_option_1_btns[i].classList.remove('in-stock');
        //     } else {
        //       var_option_1_btns[i].classList.add('in-stock');
        //     }
        //   }

        //   console.log('variants_instock',variants_instock);

        //   for (let i = 0, limit = product_json.variants.length; i < limit; i++) {
        //     if (product_json.variants[i].option1 === selected_variant.option1) {
        //       // option_2s.push(product_json.variants[i]);
        //       let button = document.querySelector(`.js-variant-option-group[data-option='${product_json.options[1]}'] .js-variant-option-button[data-value='${product_json.variants[i].option2}']`);
        //       if (product_json.variants[i].available) {
        //         // console.log('in stock', product_json.variants[i]);
        //         button.classList.add('in-stock');
        //       } else {
        //         // console.log('sold out', product_json.variants[i]);
        //         button.classList.remove('in-stock');
        //       }
        //     }
        //   }
        // }
      }
  }

  // Regular slider
  if (
    document.querySelector('.js-product-slider') && !document.querySelector('.js-product-gold-silver-selector') && 
    !document.querySelector('.js-product-slider-gs-fine')) {
    const product_modal = document.querySelector('.js-product-modal');
    const product_modal_close = document.querySelector('.js-close-product-modal');
    const product_images = document.querySelectorAll('.js-product-slide');
    const product_modal_thumbnails = document.querySelectorAll('.js-product-modal-thumbnail');
    const product_modal_images = document.querySelectorAll('.js-product-modal-image');

    for (let i = 0, limit = product_images.length; i < limit; i++) {
      product_images[i].addEventListener('click', (e) => {
  
        document.body.classList.add('prevent-scroll', 'product-modal--open');
        
        for (let j = 0, limit = product_modal_thumbnails.length; j < limit; j++) {
          product_modal_thumbnails[j].classList.remove('product-modal__thumbnail--active');
          product_modal_images[j].classList.remove('product-modal__image--active');
        }
  
        product_modal_thumbnails[i].classList.add('product-modal__thumbnail--active');
        product_modal_images[i].classList.add('product-modal__image--active');
  
        product_modal.classList.remove('hidden');
        window.requestAnimationFrame(() => {
          product_modal.classList.remove('opacity-0');
        });
  
      })
    }
  
    product_modal_close.addEventListener('click', (e) => {
      product_modal.addEventListener('transitionend', (e) => {
        product_modal.classList.add('hidden');
        document.body.classList.remove('prevent-scroll', 'product-modal--open');
      }, {once: true});
      product_modal.classList.add('opacity-0');
    });
  
    for (let i = 0, limit = product_modal_thumbnails.length; i < limit; i++) {
      product_modal_thumbnails[i].addEventListener('click', (e) => {
        for (let j = 0, limit = product_modal_thumbnails.length; j < limit; j++) {
          product_modal_thumbnails[j].classList.remove('product-modal__thumbnail--active');
          product_modal_images[j].classList.remove('product-modal__image--active');
        }
        product_modal_thumbnails[i].classList.add('product-modal__thumbnail--active');
        product_modal_images[i].classList.add('product-modal__image--active');
      });
    }
  
  
    if (!isDekstop()) {
      // Product Mobile Slider
      const product_image_slider = document.querySelector('.js-product-slider');
      if (product_image_slider.childElementCount > 1) {
        let flkty = new Flickity( product_image_slider, {
          // options
          imagesLoaded: true,
          cellAlign: 'center',
          pageDots: true,
          prevNextButtons: false,
          wrapAround: true,
          on: {
            ready: function() {
              window.dispatchEvent(new Event('resize'));
              product_image_slider.classList.remove('product-slider--hidden');
            }
          }
        });
      } else {
        product_image_slider.classList.remove('product-slider--hidden');
      }
    }
  }

  // Gold silver slider
  if (
    document.querySelector('.js-product-slider') && document.querySelector('.js-product-gold-silver-selector') ||
    document.querySelector('.js-product-slider-gs-fine') && document.querySelector('.js-variant-option-button') || 
    document.querySelector('.js-product-slider-gs-sold-out')
    ) {

    function productModal(selector1, selector2) {
      const product_modal = document.querySelector(selector1);
      const product_modal_close = document.querySelector(selector1 + ' .js-close-product-modal');
      const product_images = document.querySelectorAll(selector2 + ' .js-product-slide');
      const product_modal_thumbnails = document.querySelectorAll(selector1 + ' .js-product-modal-thumbnail');
      const product_modal_images = document.querySelectorAll(selector1 + ' .js-product-modal-image');
  
      for (let i = 0, limit = product_images.length; i < limit; i++) {
        product_images[i].addEventListener('click', (e) => {
  
          document.body.classList.add('prevent-scroll', 'product-modal--open');
          
          for (let j = 0, limit = product_modal_thumbnails.length; j < limit; j++) {
            product_modal_thumbnails[j].classList.remove('product-modal__thumbnail--active');
            product_modal_images[j].classList.remove('product-modal__image--active');
          }
    
          product_modal_thumbnails[i].classList.add('product-modal__thumbnail--active');
          product_modal_images[i].classList.add('product-modal__image--active');
    
          product_modal.classList.remove('hidden');
          window.requestAnimationFrame(() => {
            product_modal.classList.remove('opacity-0');
          });
    
        })
      }
    
      product_modal_close.addEventListener('click', (e) => {
        product_modal.addEventListener('transitionend', (e) => {
          product_modal.classList.add('hidden');
          document.body.classList.remove('prevent-scroll', 'product-modal--open');
        }, {once: true});
        product_modal.classList.add('opacity-0');
      });
    
      for (let i = 0, limit = product_modal_thumbnails.length; i < limit; i++) {
        product_modal_thumbnails[i].addEventListener('click', (e) => {
          for (let j = 0, limit = product_modal_thumbnails.length; j < limit; j++) {
            product_modal_thumbnails[j].classList.remove('product-modal__thumbnail--active');
            product_modal_images[j].classList.remove('product-modal__image--active');
          }
          product_modal_thumbnails[i].classList.add('product-modal__thumbnail--active');
          product_modal_images[i].classList.add('product-modal__image--active');
        });
      }
    }

    productModal('.js-product-modal-gold', '.js-product-images-gold');
    productModal('.js-product-modal-silver', '.js-product-images-silver');
    
  
    if (!isDekstop()) {
      // Product Mobile Slider
      const product_image_slider_gold = document.querySelector('.js-product-images-gold');
      if (product_image_slider_gold.childElementCount > 1) {
        let flkty = new Flickity( product_image_slider_gold, {
          // options
          imagesLoaded: true,
          cellAlign: 'center',
          pageDots: true,
          prevNextButtons: false,
          wrapAround: true,
          on: {
            ready: function() {
              window.dispatchEvent(new Event('resize'));
              product_image_slider_gold.classList.remove('product-slider--hidden');
            }
          }
        });
      } else {
        product_image_slider_gold.classList.remove('product-slider--hidden');
      }

      const product_image_slider_silver = document.querySelector('.js-product-images-silver');
      if (product_image_slider_silver.childElementCount > 1) {
        let flkty = new Flickity( product_image_slider_silver, {
          // options
          imagesLoaded: true,
          cellAlign: 'center',
          pageDots: true,
          prevNextButtons: false,
          wrapAround: true,
          on: {
            ready: function() {
              window.dispatchEvent(new Event('resize'));
              product_image_slider_silver.classList.remove('product-slider--hidden');
            }
          }
        });
      } else {
        product_image_slider_silver.classList.remove('product-slider--hidden');
      }
    }
  }

  if (document.querySelector('.js-product-gold-silver-selector')) {
    let gold_silver_buttons = document.querySelectorAll('.js-product-gold-silver-selector');
    const size_selector = document.querySelector('.js-product-option-size');
    const single_variant_selector = document.getElementById('variant-selector');

    const image_sliders = document.querySelectorAll('.js-product-slider');

    gold_silver_buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        gold_silver_buttons.forEach((button) => {
          button.classList.remove('product-gold-silver-selector--selected');
        });
        button.classList.add('product-gold-silver-selector--selected');
        
        let selected_color = button.dataset.color.toLowerCase();
        let selected_slider = document.querySelector('.js-product-images-' + selected_color);

        if (!isDekstop()) {
          if (selected_color === 'gold') {
            selected_slider.style.minHeight = document.querySelector('.js-product-images-silver').getBoundingClientRect().height + 'px';
          } else {
            selected_slider.style.minHeight = document.querySelector('.js-product-images-gold').getBoundingClientRect().height + 'px';
          }
        }

        image_sliders.forEach((elem) => {
          elem.classList.remove('product-images-gs--active');
        });

        selected_slider.classList.add('product-images-gs--active');

        if (!isDekstop()) {
          Flickity.data(selected_slider).select(0);
          window.dispatchEvent(new Event('resize'));
  
          setTimeout(() => {
            selected_slider.style.minHeight = '';
          }, 200);
        }

        if (size_selector) {
          let variant_title = button.dataset.color + ' / ' + size_selector.value;
          let selected_variant = single_variant_selector.querySelector(`[data-variant="${variant_title}"`);
          selected_variant.selected = true;
          // disableATCSoldOut(selected_variant);

          single_variant_selector.dispatchEvent(new Event('change'));
        } else {
          let selected_variant = single_variant_selector.querySelector(`[data-variant="${button.dataset.color}"`);
          selected_variant.selected = true;
          // disableATCSoldOut(selected_variant);
          single_variant_selector.dispatchEvent(new Event('change'));
        }
      });
    });

    if (size_selector) {
      size_selector.addEventListener('change', () => {
        let gold_silver_button = document.querySelector('.js-product-gold-silver-selector.product-gold-silver-selector--selected').dataset.color;
        let variant_title = gold_silver_button + ' / ' + size_selector.value;
        let selected_variant = single_variant_selector.querySelector(`[data-variant="${variant_title}"`);
        selected_variant.selected = true;
        // disableATCSoldOut(selected_variant);
        single_variant_selector.dispatchEvent(new Event('change'));
      });
    }

    document.querySelector('.js-product-gold-silver-selector.product-gold-silver-selector--selected').dispatchEvent(new Event('click'));
  }

  // Variant buttons
  if (document.querySelector('.js-variant-option-button')) {
    let variant_buttons = document.querySelectorAll('.js-variant-option-button');
    let variant_options = document.querySelectorAll('.js-variant-option-select').length;

    function disableButtons() {
      const product_json = JSON.parse(document.querySelector('.js-product-json').innerHTML);
      let options = document.querySelectorAll('.js-variant-option-group');
  
      if (document.querySelectorAll('.js-variant-option-button.selected').length === options.length) {
        if (options.length === 3) {
          let variant_exists = product_json.variants.some((variant) => {
            return (
              variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value &&
              variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value &&
              variant.option3 === options[2].querySelector('.js-variant-option-button.selected').dataset.value
            );
          });
  
          let option_2s = options[1].querySelectorAll('.js-variant-option-button');
          let option_3s = options[2].querySelectorAll('.js-variant-option-button');
          console.log('variant_exists', variant_exists);
  
          if (!variant_exists) {
            // Check if another option 3 exists
            let alt_3 = false;
            for (let i = 0, limit = option_3s.length; i < limit; i++) {
              let value = option_3s[i].dataset.value;
              alt_3 = product_json.variants.some((variant) => {
                let variant_exists = variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value &&
                variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value &&
                variant.option3 === value;
  
                return variant_exists;
              });
  
              if (alt_3) {
                options[2].querySelector('.js-variant-option-button.selected').classList.remove('selected');
                options[2].querySelector(`.js-variant-option-button[data-value="${value}"]`).classList.add('selected');
                options[2].querySelector('.js-variant-option-select').value = value;
  
                break
              }
            }
  
            if (!alt_3) {
              // Find first available option 2
              let variants_with_selected = product_json.variants.filter((variant) => {
                return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value;
              });
  
              console.log('variants_with_selected', variants_with_selected);
              console.log('alt_2', variants_with_selected[0].option2, variants_with_selected[0].option3);
  
              options[1].querySelector('.js-variant-option-button.selected').classList.remove('selected');
              options[1].querySelector(`.js-variant-option-button[data-value="${variants_with_selected[0].option2}"]`).classList.add('selected');
              options[1].querySelector('.js-variant-option-select').value = variants_with_selected[0].option2;
  
              options[2].querySelector('.js-variant-option-button.selected').classList.remove('selected');
              options[2].querySelector(`.js-variant-option-button[data-value="${variants_with_selected[0].option3}"]`).classList.add('selected');
              options[2].querySelector('.js-variant-option-select').value = variants_with_selected[0].option3;
            }
          }
  
          // Check if any options dont exist and button needs to be disabled
          let variants_with_selected_1 = product_json.variants.filter((variant) => {
            return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value;
          });
  
          for (let i = 0, limit = option_2s.length; i < limit; i++) {
            option_2s[i].disabled = !variants_with_selected_1.some((variant) => {
              return variant.option2 === option_2s[i].dataset.value;
            });
          }
  
          let variants_with_selected_2 = product_json.variants.filter((variant) => {
            return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value && variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value;
          });
  
          for (let i = 0, limit = option_3s.length; i < limit; i++) {
            option_3s[i].disabled = !variants_with_selected_2.some((variant) => {
              return variant.option3 === option_3s[i].dataset.value;
            });
          }
  
        } else if (options.length === 2) {
          let variant_exists = product_json.variants.some((variant) => {
            return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value && variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value;
          });
  
          let variants_with_selected = product_json.variants.filter((variant) => {
            return variant['option1'] === options[0].querySelector('.js-variant-option-button.selected').dataset.value;
          });
  
          // If it doesn't exist change selection
          if (!variant_exists) {
            options[1].querySelector('.js-variant-option-button.selected').classList.remove('selected');
            options[1].querySelector(`.js-variant-option-button[data-value="${variants_with_selected[0].option2}"]`).classList.add('selected');
            options[1].querySelector('.js-variant-option-select').value = variants_with_selected[0].option2;
          }
  
          let option_2s = options[1].querySelectorAll('.js-variant-option-button');
  
          // Check if 
          for (let i = 0, limit = option_2s.length; i < limit; i++) {
            option_2s[i].disabled = !variants_with_selected.some((variant) => {
              return variant.option2 === option_2s[i].dataset.value;
            });
          }
        }
      }
    }

    disableButtons();

    variant_buttons.forEach((button) => {
      button.addEventListener('click', (e) => {

        const product_json = JSON.parse(document.querySelector('.js-product-json').innerHTML);
        let option = button.dataset.value;
        let variant_option_group = button.closest('.js-variant-option-group');
        let variant_select = button.closest('.js-variant-option-group').querySelector('.js-variant-option-select');
        let previous_option = variant_option_group.querySelector('.js-variant-option-button.selected');

        previous_option?.classList.remove('selected');
        button.classList.add('selected');
        variant_option_group.classList.add('selected');
        variant_select.value = option;

        // Update option buttons
        disableButtons();

        let options = document.querySelectorAll('.js-variant-option-group');

        if (document.querySelectorAll('.js-variant-option-button.selected').length === options.length) {
          if (options.length === 3) {
            let variant_exists = product_json.variants.some((variant) => {
              return (
                variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value &&
                variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value &&
                variant.option3 === options[2].querySelector('.js-variant-option-button.selected').dataset.value
              );
            });

            let option_2s = options[1].querySelectorAll('.js-variant-option-button');
            let option_3s = options[2].querySelectorAll('.js-variant-option-button');
            console.log('variant_exists', variant_exists);

            if (!variant_exists) {
              // Check if another option 3 exists
              let alt_3 = false;
              for (let i = 0, limit = option_3s.length; i < limit; i++) {
                let value = option_3s[i].dataset.value;
                alt_3 = product_json.variants.some((variant) => {
                  let variant_exists = variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value &&
                  variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value &&
                  variant.option3 === value;

                  return variant_exists;
                });

                if (alt_3) {
                  options[2].querySelector('.js-variant-option-button.selected').classList.remove('selected');
                  options[2].querySelector(`.js-variant-option-button[data-value="${value}"]`).classList.add('selected');
                  options[2].querySelector('.js-variant-option-select').value = value;

                  break
                }
              }

              if (!alt_3) {
                // Find first available option 2
                let variants_with_selected = product_json.variants.filter((variant) => {
                  return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value;
                });

                console.log('variants_with_selected', variants_with_selected);
                console.log('alt_2', variants_with_selected[0].option2, variants_with_selected[0].option3);

                options[1].querySelector('.js-variant-option-button.selected').classList.remove('selected');
                options[1].querySelector(`.js-variant-option-button[data-value="${variants_with_selected[0].option2}"]`).classList.add('selected');
                options[1].querySelector('.js-variant-option-select').value = variants_with_selected[0].option2;

                options[2].querySelector('.js-variant-option-button.selected').classList.remove('selected');
                options[2].querySelector(`.js-variant-option-button[data-value="${variants_with_selected[0].option3}"]`).classList.add('selected');
                options[2].querySelector('.js-variant-option-select').value = variants_with_selected[0].option3;
              }
            }

            // Check if any options dont exist and button needs to be disabled
            let variants_with_selected_1 = product_json.variants.filter((variant) => {
              return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value;
            });

            for (let i = 0, limit = option_2s.length; i < limit; i++) {
              option_2s[i].disabled = !variants_with_selected_1.some((variant) => {
                return variant.option2 === option_2s[i].dataset.value;
              });
            }

            let variants_with_selected_2 = product_json.variants.filter((variant) => {
              return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value && variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value;
            });

            for (let i = 0, limit = option_3s.length; i < limit; i++) {
              option_3s[i].disabled = !variants_with_selected_2.some((variant) => {
                return variant.option3 === option_3s[i].dataset.value;
              });
            }

          } else if (options.length === 2) {
            let variant_exists = product_json.variants.some((variant) => {
              return variant.option1 === options[0].querySelector('.js-variant-option-button.selected').dataset.value && variant.option2 === options[1].querySelector('.js-variant-option-button.selected').dataset.value;
            });

            let variants_with_selected = product_json.variants.filter((variant) => {
              return variant['option1'] === options[0].querySelector('.js-variant-option-button.selected').dataset.value;
            });

            // If it doesn't exist change selection
            if (!variant_exists) {
              options[1].querySelector('.js-variant-option-button.selected').classList.remove('selected');
              options[1].querySelector(`.js-variant-option-button[data-value="${variants_with_selected[0].option2}"]`).classList.add('selected');
              options[1].querySelector('.js-variant-option-select').value = variants_with_selected[0].option2;
            }

            let option_2s = options[1].querySelectorAll('.js-variant-option-button');

            // Check if 
            for (let i = 0, limit = option_2s.length; i < limit; i++) {
              option_2s[i].disabled = !variants_with_selected.some((variant) => {
                return variant.option2 === option_2s[i].dataset.value;
              });
            }
          }
        }

        if (variant_options === document.querySelectorAll('.js-variant-option-group.selected').length) {
          variant_select.dispatchEvent(new Event('change'));
        }

        if (document.querySelector('.js-product-images-gold') && variant_option_group.dataset.option.toLowerCase() === 'material') {
          let option_check = option.toLowerCase();
          let its_gold = (option_check.includes("yellow") || option_check.includes("vermeil")) ? true : false;

          // console.log(option_check, its_gold);

          let selected_slider;
          if (!isDekstop()) {
            if (its_gold) {
              selected_slider = document.querySelector('.js-product-images-gold');
              selected_slider.style.minHeight = document.querySelector('.js-product-images-silver').getBoundingClientRect().height + 'px';
            } else {
              selected_slider = document.querySelector('.js-product-images-silver');
              selected_slider.style.minHeight = document.querySelector('.js-product-images-gold').getBoundingClientRect().height + 'px';
            }
          }

          const image_sliders = document.querySelectorAll('.js-product-slider');
          image_sliders.forEach((elem) => {
            elem.classList.remove('product-images-gs--active');
          });

          // console.log('selected_slider',selected_slider)

          if (!isDekstop()) {
            Flickity.data(selected_slider).select(0);
            window.dispatchEvent(new Event('resize'));
    
            setTimeout(() => {
              selected_slider.style.minHeight = '';
            }, 200);
          }
          
          if (its_gold) {
            document.querySelector('.js-product-images-gold').classList.add('product-images-gs--active');
          } else {
            document.querySelector('.js-product-images-silver').classList.add('product-images-gs--active');
          }
        }
      });
    });
  }

  if (document.querySelector('.js-variant-option-select')) {
    // const add_to_cart = document.querySelector('.js-add-to-cart');
    // const sold_out = document.querySelector('.js-product-sold-out');
    const single_option_selector = document.getElementById('variant-selector');
    const options = document.querySelectorAll('.js-variant-option-select');
    options.forEach((elem) => {
      elem.addEventListener('change', (e) => {
        let selected_options = document.querySelectorAll('.js-variant-option-select');
        let current_variant = '';
        selected_options.forEach((elem) => {
          current_variant += elem.value;
          current_variant += ' / ';
        });
        current_variant = current_variant.substring(0, current_variant.length - 3);
        // console.log('current_variant',current_variant);
        let selected_option = single_option_selector.querySelector(`[data-variant='${current_variant}'`);
        // console.log('selected_option',selected_option);
        selected_option.selected = true;
        // disableATCSoldOut(selected_option);
        single_option_selector.dispatchEvent(new Event('change'));
      });
    });
    // document.querySelector('.js-variant-option-select').dispatchEvent(new Event('change'));
  }

  function disableATCSoldOut(selected_option) {
    const add_to_cart = document.querySelector('.js-add-to-cart');
    // selected_option.selected = true;

    if (selected_option.dataset.soldOut === 'true') {
      if(add_to_cart) {
        add_to_cart.value = "SOLD OUT";
      }
      if (document.querySelector('.js-preorder-info')) {
        let pre_order_message = document.querySelector('.js-preorder-info');
        let pre_order_property = document.getElementById('preorder-eta');
        pre_order_message.classList.add('pdp-preorder-info--hidden');
        pre_order_message.textContent = '';
        pre_order_property.name = '_';
        pre_order_property.value = '';
      }

      if(add_to_cart) {
        window.requestAnimationFrame(() => {
          add_to_cart.disabled = true;
        });
      }
      if(document.querySelector('.js-back-in-stock')) {
        document.querySelector('.js-back-in-stock').classList.remove('hidden');
      }
    } else {
      if (selected_option.dataset.preorder.length > 0) {
        if(add_to_cart) {
          add_to_cart.value = "PRE-ORDER";
        }
        let pre_order_message = document.querySelector('.js-preorder-info');
        let pre_order_property = document.getElementById('preorder-eta');
        pre_order_message.classList.remove('pdp-preorder-info--hidden');
        pre_order_message.textContent = 'Pre-Order - Ships ' + selected_option.dataset.preorder;
        pre_order_property.name = 'properties[Pre-Order]';
        pre_order_property.value = 'Ships ' + selected_option.dataset.preorder;
      } else {
        if(add_to_cart) {
          add_to_cart.value = "ADD TO CART";
        }
        let pre_order_message = document.querySelector('.js-preorder-info');
        let pre_order_property = document.getElementById('preorder-eta');
        pre_order_message.classList.remove('pdp-preorder-info--hidden');
        pre_order_message.textContent = 'In Stock - Ships in 1-3 Business Days';
        pre_order_property.name = 'properties[In Stock]';
        pre_order_property.value = 'Ships in 1-3 Business Days';
      }

      if (document.querySelector('.js-type-tester-text')) {
        disableATCTypeTester();
      } else {
        if(add_to_cart) {
          window.requestAnimationFrame(() => {
            add_to_cart.disabled = false;
          });
        }
      }

      if(document.querySelector('.js-back-in-stock')) {
        document.querySelector('.js-back-in-stock').classList.add('hidden');
      }
    }
  }

  // Type Tester
  if (document.querySelector('.js-type-tester-sample')) {
    const tt_font = document.querySelector('.js-type-tester-font');
    const tt_text = document.querySelector('.js-type-tester-text');
    const tt_sample = document.querySelector('.js-type-tester-sample');
    const tt_uppercase = document.querySelector('.js-type-tester-text-uppercase');

    tt_font.addEventListener('change', () => {
      let current_font = tt_font.options[tt_font.selectedIndex].dataset.font;
      tt_font.classList.forEach((class_name) => {
        if (class_name.includes('font-')) {
          tt_font.classList.remove(class_name);
          tt_sample.classList.remove(class_name);
        }
      });
      tt_font.classList.add(current_font);
      tt_sample.classList.add(current_font);
    });

    const debouncedSample = debounceSample(updateSample, 500);
    function debounceSample(func, wait) {
      let timeout;
    
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
    
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    function updateSample() {

      let sample = tt_text.value;

      if (tt_uppercase) {
        sample = sample.toUpperCase();
      }

      sample = sample.replace(/[^a-zA-Z0-9]/g, '');

      tt_text.value = sample;
      tt_sample.textContent = sample;
    }

    tt_text.addEventListener('input', debouncedSample);
    tt_text.addEventListener('input', () => {
      disableATCTypeTester();
    });

    disableATCTypeTester();
  }

  function disableATCTypeTester() {
    const tt_text = document.querySelector('.js-type-tester-text');
    const button = document.querySelector('.js-add-to-cart');
    if (tt_text.value.length === 0 || tt_text.value.length < parseInt(tt_text.getAttribute('minlength'))) {
      window.requestAnimationFrame(() => {
        button.disabled = true;
      });
    } else {
      window.requestAnimationFrame(() => {
        button.disabled = false;
      });
    }
  }

  function plpGSSwatches() {
    const gold_swatches = document.querySelectorAll('.js-plp-swatch-gold');
    const silver_swatches = document.querySelectorAll('.js-plp-swatch-silver');

    gold_swatches.forEach((elem) => {
      if (!elem.classList.contains('js-plp-swatch-listener')) {
        elem.classList.add('js-plp-swatch-listener');
        elem.addEventListener('click', (e) => {
          e.preventDefault();
          // console.log ('gold click');
          let product = elem.closest('.js-collection-product');
          product.classList.add('collection-product--gold');
          product.classList.remove('collection-product--silver');
        });
      }
    });

    silver_swatches.forEach((elem) => {
      if (!elem.classList.contains('js-plp-swatch-listener')) {
        elem.classList.add('js-plp-swatch-listener');
        elem.addEventListener('click', (e) => {
          e.preventDefault();
          // console.log ('silver click');
          let product = elem.closest('.js-collection-product');
          product.classList.add('collection-product--silver');
          product.classList.remove('collection-product--gold');
          elem.classList.add('js-plp-swatch-listener');
        });
      }
    });
  }

  if (document.querySelector('.js-collection-products')) {
    plpGSSwatches();
  }

  function updateSoldOutGold() {
    document.querySelectorAll('.collection-product--gold').forEach((elem) => {
      let sold_out_gold = elem.querySelector('.plp-sold-out--gold');
      let sold_out_silver = elem.querySelector('.plp-sold-out--silver');

      if (sold_out_gold) {
        elem.querySelector('.plp-images-gold')?.classList.add('opacity-50');
      }

      if (sold_out_silver) {
        elem.querySelector('.plp-images-silver')?.classList.add('opacity-50');
      }

      if (sold_out_gold && !sold_out_silver) {
        elem.classList.remove('collection-product--gold');
        elem.classList.add('collection-product--silver');
      }
    });
  }

  if (document.querySelector('.collection-product--gold')) {
    updateSoldOutGold();
  }

  const wishlist_popup = document.querySelector('.js-wishlist-popup');
  if (wishlist_popup) {
    const wishlist_button = document.querySelector('.js-wishlist-header');
    const wishlist_mobile = document.querySelector('.js-wishlist-mobile');
    const wishlist_collection_buttons = document.querySelectorAll('.js-wishlist-collection-blocker');
    const wishlist_product_buttons = document.querySelectorAll('.js-wishlist-product-blocker');
    const wishlist_popup_overlay = document.querySelector('.js-wishlist-popup-overlay');
    const wishlist_popup_close = document.querySelector('.js-wishlist-popup-close');
    const open_wishlist_popup = function(e) {
      e.preventDefault();
      let scrollHeight = window.scrollY;

      window.wishlistPopupScroll = scrollHeight;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.position = 'absolute';
      document.documentElement.style.inset = '0px';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'absolute';
      document.body.style.height = 'unset';
      document.body.style.inset = `-${scrollHeight}px 0px 0px`;
      wishlist_popup.style.display = 'block';
      window.requestAnimationFrame(() => {
        wishlist_popup.style.opacity = '1';
      });
    };
    const close_wishlist_popup = function() {
      let scrollHeight = window.wishlistPopupScroll || 0;

      wishlist_popup.addEventListener('transitionend', () => {
        wishlist_popup.style.display = '';
      }, {once: true});

      document.documentElement.style.overflow = '';
      document.documentElement.style.position = '';
      document.documentElement.style.inset = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
      document.body.style.inset = '';
      window.scrollBy(0, scrollHeight);

      window.requestAnimationFrame(() => {
        wishlist_popup.style.opacity = '0';
      });
      // wishlist_popup.style.display = '';
    };
    wishlist_button.addEventListener('click', open_wishlist_popup);
    wishlist_mobile.addEventListener('click', open_wishlist_popup);
    wishlist_popup_close.addEventListener('click', close_wishlist_popup);
    wishlist_popup_overlay.addEventListener('click', close_wishlist_popup);
    wishlist_collection_buttons.forEach((elem) => {
      elem.addEventListener('click', open_wishlist_popup);
    });
    wishlist_product_buttons.forEach((elem) => {
      elem.addEventListener('click', open_wishlist_popup);
    });
  }

  document.addEventListener('wk:wishlist:add:success', (e) => {
    let wishlist_product = document.querySelector(`.js-wishlist-product-container[data-id="${e.detail.data.product.id}"]`);

    if (wishlist_product) {
      let tooltip_add = wishlist_product.querySelector('.js-wishlist-added');
      let tooltip_remove = wishlist_product.querySelector('.js-wishlist-removed');
      // console.log('wish granted', wishlist_product);
  
      if (tooltip_remove.classList.contains('wishlist-notification--active')) {
        tooltip_remove.classList.remove('wishlist-notification--active');
      }

      tooltip_add.classList.add('wishlist-notification--active');
      tooltipTimeout = setTimeout(() => {
        tooltip_add.classList.remove('wishlist-notification--active');
      }, 1500);
    }
  });

  document.addEventListener('wk:wishlist:remove:success', (e) => {
    let wishlist_product = document.querySelector(`.js-wishlist-product-container[data-id="${e.detail.data.product.id}"]`);

    if (wishlist_product) {
      let tooltip_add = wishlist_product.querySelector('.js-wishlist-added');
      let tooltip_remove = wishlist_product.querySelector('.js-wishlist-removed');
      // console.log('wish recinded', wishlist_product);
  
      if (tooltip_add.classList.contains('wishlist-notification--active')) {
        tooltip_add.classList.remove('wishlist-notification--active');
      }
      
      tooltip_remove.classList.add('wishlist-notification--active');
      tooltipTimeout = setTimeout(() => {
        tooltip_remove.classList.remove('wishlist-notification--active');
      }, 1500);
    }
  });
});